import Vue from 'vue'
import Vuex from 'vuex'
// import createLogger from 'vuex/dist/logger'
import app from './modules/app.js'
import auth from './modules/auth.js'
import alert from './modules/alert.js'
import bodyArea from './modules/bodyArea.js'
import call from './modules/call.js'
import checkup from './modules/checkup.js'
import chat from './modules/chat.js'
import clinic from './modules/clinic.js'
import doctor from './modules/doctor.js'
import head from './modules/head.js'
import infermedica from './modules/infermedica.js'
import interview from './modules/interview.js'
import labtest from './modules/labtest.js'
import medicalitem from './modules/medicalitem.js'
import message from './modules/message.js'
import notification from './modules/notification.js'
import panel from './modules/panel.js'
import patientLogType from './modules/patientLogType.js'
import pcase from './modules/case.js'
import register from './modules/register.js'
import schedule from './modules/schedule.js'
import service from './modules/service.js'
import servicecat from './modules/servicecat.js'
import servicetpl from './modules/servicetpl.js'
import speciality from './modules/speciality.js'
import staticservice from './modules/staticservice.js'
import status from './modules/status.js'
import user from './modules/user.js'

import webSocketPlugin from './plugins/websocket.js'

Vue.use(Vuex)
// createLogger()
export default new Vuex.Store({
  strict: true,
  plugins: process.env.NODE_ENV !== 'production' ? [webSocketPlugin()] : [webSocketPlugin()],
  modules: {
    app,
    auth,
    alert,
    bodyArea,
    call,
    checkup,
    chat,
    clinic,
    doctor,
    head,
    infermedica,
    interview,
    labtest,
    medicalitem,
    message,
    notification,
    panel,
    patientLogType,
    pcase,
    register,
    schedule,
    service,
    servicecat,
    servicetpl,
    speciality,
    staticservice,
    status,
    user
  }
})
